import React from 'react'
import { Header } from '../../components/navigation/header/Header'
import { Footer } from '../../components/navigation/footer/Footer'
import { About } from '../../components/about/About'
import { FAQList } from '../../components/faq/list/FAQList.js'
import { VegaHeading } from '../../components/vega/heading/Heading'
import style from './error.module.scss'
import { useTranslation } from 'react-i18next'
import { VegaButton } from '../../components/vega/button/Button'
import cx from 'classnames'

export const Error = ({ code }) => {
	const { t } = useTranslation()

	const errorCode = [400, 404, 500].includes(code) ? code : 500

	return (
		<div className={style.error}>
			<Header />
			<div className={cx(style.content, 'animate__animated', 'animate__fadeInRight')}>
				<VegaHeading className={style.title} label={errorCode} tag={'h1'} />
				<VegaHeading
					className={style.subtitle}
					label={t(`Error${errorCode}Subtitle`)}
					tag={'h1'}
				/>
				<div className={style.description}>{t(`Error${errorCode}Description`)}</div>
				<VegaButton
					label={t(`Error${errorCode}ButtonLabel`)}
					onClick={() => (window.location.href = t(`ErrorButtonHref`))}
				/>
			</div>
			<FAQList />
			<About />
			<Footer />
		</div>
	)
}
